import {
    SET_BULK_ORDER_COST_CENTER,
    SET_COSTCENTER_WITH_DIVISIONID,
    SET_COST_CENTERS, 
    SET_COST_CENTER_BY_GROUP, 
    SET_COST_CENTER_BY_REGION, 
    SET_COST_CENTER_GROUPS,
    SET_COST_CENTERS_BY_BRANCH,
    SET_COST_CENTER_BY_SEARCH_STRING
} from './CostCentersType';


const reducers = (state = [], action: any) => {
    switch (action.type) {
        case SET_COST_CENTERS:
            return {
                ...state,
                costCentersDropDownList: action.costCentersDropDownList,
            };
        case SET_COST_CENTER_GROUPS:
            return {
                ...state,
                costCenterGroupDropDownList: action.groupList,
            };
        case SET_COST_CENTER_BY_REGION:
            return {
                ...state,
                costCenterByRegionDropDownList: action.costCenterList,
            };
        case SET_COST_CENTER_BY_GROUP:
            return {
                ...state,
                costCenterByGroupDropDownList: action.costCenterList,
            };
        case SET_COSTCENTER_WITH_DIVISIONID:
            return {
                ...state,
                costCenterWithDivisionId: action.costCenterWithDivisionId
            }
        case SET_BULK_ORDER_COST_CENTER:
            return {
                ...state,
                bulkOrderCostCenterList: action.costCenterList,
            };
        case SET_COST_CENTERS_BY_BRANCH:
            return {
                ...state,
                costCenterByBranchDropDownList: action.response,
            };
        case SET_COST_CENTER_BY_SEARCH_STRING:
            return {
                ...state,
                costCenterBySearchDropDownList: action.response,
            };
        default:
            return state;
    }
}

export {
    reducers
}